import {LOCALE_ID, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {RouteReuseStrategy} from '@angular/router';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {DatePipe, registerLocaleData} from '@angular/common';
import localeIt from '@angular/common/locales/it';
import {SharedModule} from './shared.module';
import {SelectModule} from './select.module';
import {IonicRouteStrategy} from '@ionic/angular';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {DashboardHomeComponent} from './dashboard-home/dashboard-home.component';
import {DashboardQuickActionComponent} from './dashboard-home/dashboard-quick-action.component';
import {JwtInterceptor} from './_services/jwt.interceptor';
import {ErrorInterceptor} from './_services/error.interceptor';

registerLocaleData(localeIt);

@NgModule({
  declarations: [
    AppComponent,
    DashboardHomeComponent
  ],
  imports: [
    BrowserModule,
    SharedModule,
    DashboardQuickActionComponent,
    SelectModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule
  ],
  providers: [
    {provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true},
    {provide: RouteReuseStrategy, useClass: IonicRouteStrategy},
    {provide: LOCALE_ID, useValue: 'it-IT'},
    [DatePipe]
  ],
  bootstrap: [
    AppComponent
  ],
})
export class AppModule {}
